/** @format */

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../hooks/useAuth";

export const ProtectedRoute = ({
	children,
	allowedGroups,
}: {
	children: React.ReactNode;
	allowedGroups?: readonly string[];
}) => {
	const { isAuthenticated, isLoading, isSessionExpired, login, user } = useAuth();
	const { t } = useTranslation();

	useEffect(() => {
		if (!isLoading && (!isAuthenticated || isSessionExpired)) {
			login();
		}
	}, [isLoading, isAuthenticated, isSessionExpired, login]);

	if (isLoading || !isAuthenticated || isSessionExpired) {
		return null;
	}

	if (allowedGroups && !allowedGroups.includes(user?.group ?? "")) {
		return (
			<div className="flex min-h-screen flex-col items-center justify-center gap-2 p-6 text-center">
				<h1 className="text-xl font-semibold text-slate-900">{t("accessDenied.title")}</h1>
				<p className="text-sm text-slate-600">{t("accessDenied.message")}</p>
			</div>
		);
	}

	return <>{children}</>;
};
